import { API, handleApiError } from "./utils";

export const getZones = async (search, sortOrder, sortedColumn, page, per_page, sites, Risk_level, order_by) => {
    try {
        const { data } = await API.get("/get_zones", {
            params: {
                search,
                sortOrder,
                sortedColumn,
                sites,
                Risk_level,
                page,
                per_page,
                order_by
            },
        });
        return { error: null, data };
    } catch (error) {
        return handleApiError(error);
    }
};
export const zoneGet = async (id) => {
    try {
        const { data } = await API.get(`/zones/${id}`);
        // console.log("zoneGet", await API.get(`/zones/${id}`))
        return { error: null, data };
    } catch (error) {
        return handleApiError(error);
    }
};
export const zoneAdd = async (zone) => {
    try {
        const { data } = await API.post("/zones/", null, {
            params: {
                site_id: zone.Site_ID,
                zone_name: zone.Zone_name,
                risk_level: zone.Risk_level,
                zone_description: zone.Zone_description,
                polygon_json: zone.Polygon_json || null,
                fill_color: zone.Fill_color || null,
                label_position: zone.Label_position || null,

            },

        });
        return { error: null, data };
    } catch (error) {
        return handleApiError(error);
    }
};
export const zoneUpdate = async (zone) => {
    try {
        const { data } = await API.put(`/zones/${zone.Zone_ID}`, null, {
            params: {
                site_id: zone.Site_ID,
                zone_name: zone.Zone_name,
                risk_level: zone.Risk_level,
                zone_description: zone.Zone_description,
                polygon_json: zone.Polygon_json || null,
                fill_color: zone.Fill_color || null,
                label_position: zone.Label_position || null,
            }
        });
        return { error: null, data };
    } catch (error) {
        return handleApiError(error);
    }
};
export const zoneDelete = async (id, options = {}) => {
    try {
        const { data } = await API.delete(`/zones/${id}`, {
            skipSuccessToast: options.skipSuccessToast || false,
        });
        return { error: null, data };
    } catch (error) {
        return handleApiError(error);
    }
};
